import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SitePublicService} from 'src/app/services/site-public.service';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {Subscription} from 'rxjs';
import {ExhibitorDialogComponent} from '../../dialogs/exhibitor-dialog/exhibitor-dialog.component';
import {Clipboard} from '@angular/cdk/clipboard';
import {ExhibitorPDFDialogComponent} from '../../dialogs/exhibitor-pdf-dialog/exhibitor-pdf-dialog.component';

@Component({
  selector: 'app-exhibitors',
  templateUrl: './exhibitors.component.html',
  styleUrls: [ './exhibitors.component.scss' ]
})
export class ExhibitorsComponent implements OnInit, OnDestroy {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'icon', 'position', 'title', 'edit', 'preview', 'delete' ];

  public dataSourcePDF: MatTableDataSource<any>
  public displayedPDFColumns: string[] = [ 'icon', 'name', 'file', 'edit', 'preview', 'delete' ];


  @ViewChild(MatSort, {static: true}) sort: MatSort;

  private statuteSubscription: Subscription | undefined;
  private pdfsSubscription: Subscription | undefined;

  public selectedPDF: any;
  public pdfDocument$: any;

  constructor (
    private _sitePublicService: SitePublicService,
    private _dialog: MatDialog,
    private _spinnerService: SpinnerService,
    private _snackBar: SnackBarIconService,
    private _clipboard: Clipboard) {

    /*
    if (!this._authService.isAdmin) {
    this.router.navigate([ 'home' ]);
    }
    */

    this.loadExhibitors()
    this.loadbExhibitorsPDFs();
  }

  ngOnInit () {
    const documentKey = 'statute';
    this.pdfDocument$ = this._sitePublicService.getPDFByKey(documentKey);
    //console.log("pdfDocument$: " + JSON.stringify(this.pdfDocument$))
  }

  ngOnDestroy () {
    if (this.statuteSubscription) {
      this.statuteSubscription.unsubscribe();
    }
    if (this.pdfsSubscription) {
      this.pdfsSubscription.unsubscribe();
    }

  }

  loadExhibitors () {
    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const exhibitors$ = this._sitePublicService.loadExhibitors();

    // 2. Se inscreve no Observable
    this.statuteSubscription = exhibitors$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // Aqui, vamos apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar os expositor:', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  openDelete (element: any) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.title + "<br><br>Deseja excluir este documento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.delete(element.id)
      }
    })

  }

  async delete (id: string) {
    const waiting = this._spinnerService.show();

    try {
      // Chama a função e aguarda a conclusão da exclusão do Firestore e do Storage
      await this._sitePublicService.deleteExhibitors(id);

      // Exibe feedback de sucesso e atualiza a interface (ex: recarrega a lista)
      console.log(`Registro e arquivo deletados com sucesso: ${ id }`);
      this.loadExhibitors(); // Exemplo: recarrega os dados na tabela

    } catch (error) {
      console.error("Não foi possível completar a exclusão:", error);
      // Exibir mensagem de erro para o usuário
    } finally {
      waiting.close();
    }
  }

  openDialog (entity: any) {


    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'position': 0, 'title': '', 'text': ''};
    }

    let dialogRef = this._dialog.open(ExhibitorDialogComponent, {
      //width: '900px',
      //height: '680px',
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const formData = form.getRawValue();

        if (actionType == 'insert') {

          // console.log("insert: " + JSON.stringify(formData));

          await this._sitePublicService.insertExhibitors(formData)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar expositor")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });

        } else {
          // console.log("update: " + JSON.stringify(formData));
          const id = formData.id;
          const data = formData

          await this._sitePublicService.updateExhibitors(id, data)
            .then(async () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao atualizar Exhibitor")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });

        }
      })

  }

  loadbExhibitorsPDFs () {

    const waiting = this._spinnerService.show();

    // 1. Chama o serviço que retorna o Observable
    const statute$ = this._sitePublicService.loadbExhibitorsPDFs();

    // 2. Se inscreve no Observable
    this.pdfsSubscription = statute$.subscribe({
      next: (array: any[]) => {
        // Este código será executado na primeira vez E em cada mudança subsequente.
        console.log('array: ' + JSON.stringify(array));
        this.dataSourcePDF = new MatTableDataSource(array);
        this.dataSourcePDF.sort = this.sort;
        // O 'waiting.close()' deve ser feito apenas na primeira vez.
        // Uma forma simples é verificar se o spinner está aberto ou usar 'finalize' no pipe.
        // apenas fechar, assumindo que já está aberto.
        if (waiting) {
          waiting.close();
        }
      },
      error: (error) => {
        console.error('Erro ao carregar dados: ', error);
        if (waiting) {
          waiting.close();
        }
        // Trate o erro (ex: exibir mensagem para o usuário)
      },
      // O complete não é chamado, pois é um Observable "infinito" (tempo real)
    });
  }

  pdfChange (data: any) {
    const file: File = data.target.files[ 0 ]
    this.selectedPDF = file
    console.log(this.selectedPDF.name);
  }

  openDialogPDF (entity: any) {

    let data: any = {};
    if (entity) {
      data = entity;
    } else {
      data = {'id': "0", 'key': '', 'pdf_name': '', 'pdf_url': ''}
    }

    let dialogRef = this._dialog.open(ExhibitorPDFDialogComponent, {
      width: '700px',
      height: '440px',
      panelClass: 'custom-dialog-container',
      data: data
    });


    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const waiting = this._spinnerService.show()

        const actionType: string = response[ 0 ];
        const form: any = response[ 1 ];
        const file: any = response[ 2 ];
        const formData = form.getRawValue();

        console.log("actionType: " + actionType);
        console.log("formData: " + JSON.stringify(formData));
        console.log("file: " + JSON.stringify(file.name));

        if (actionType == 'insert') {

          console.log("insert: " + JSON.stringify(formData));

          await this._sitePublicService.uploadExhibitorsPDF(file, formData, "pub_exhibitors_pdfs")
            .then(async () => {
              waiting.close();
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar pdf")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
  
        } else if (actionType == 'update') {
          console.log("update: " + JSON.stringify(formData));
          /*
          await this._sitePublicService.uploadPDF(file, formData.key, "pub_exhibitors_pdfs")
            .then(async () => {
              waiting.close();
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            })
            .catch((err: any) => {
              console.log("erro ao adicionar pdf")
              this._snackBar.openSnackBar("Erro!", '', 'error')
            });
            */
        }
      })


  }

  async savePDF () {
    const file: File = this.selectedPDF;
    const key: string = 'statute'

    try {
      const url = await this._sitePublicService.uploadPDF(file, key, 'pub_exhibitors_pdfs');
      console.log("Upload e registro concluídos. URL:", url);
      // Faça algo com a URL (ex: atualizar o formulário, exibir sucesso)
    } catch (error) {
      console.error("Erro durante o processo de upload/registro:", error);
      // Trate o erro (ex: exibir mensagem para o usuário)
    }
  }

  previewContent (element) {
    const html = element.html;
    this._sitePublicService.displayHtml(html)
  }

  openDeletePDF (element) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.key + "<br><br>Excluir este pdf?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._sitePublicService.deletePDF('pub_exhibitors_pdfs', element.key)
          .then(
            () => {
              this._snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete link error: " + error.message)}
          )
      }
    })
  }

  copyToClipboard (element: any): void {

    const data = element;
    const sucesso = this._clipboard.copy(data);

    if (sucesso) {
      this._snackBar.openSnackBar("Copiado!", '', 'success')
    } else {
      console.error('Falha ao copiar a informação.');
    }
  }

}
